"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcListedDataList = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var json_stable_stringify_1 = __importDefault(require("json-stable-stringify"));
var client_1 = require("@apollo/client");
var util_1 = require("@aperza/util");
var ac_ui_1 = require("@aperza/ac-ui");
// TODO to merge this code into AcPageDataList
var AcListedDataList = function (props) {
    var _a, _b;
    var query = props.query, columns = props.columns, pathToList = props.pathToList, sorts = props.sorts, onChangeSorts = props.onChangeSorts, filter = props.filter, highlight = props.highlight, onRowClick = props.onRowClick, whenNoData = props.whenNoData, whenLoading = props.whenLoading, grid = props.grid, refetchTimestamp = props.refetchTimestamp, onDataChange = props.onDataChange, hideHeader = props.hideHeader;
    var location = react_router_dom_1.useLocation();
    var setSorts = function (currentSorts) {
        if (onChangeSorts)
            onChangeSorts(currentSorts);
    };
    var _c = client_1.useQuery(query, {
        variables: __assign({ sorts: sorts }, filter),
    }), loading = _c.loading, data = _c.data, refetch = _c.refetch, client = _c.client, networkStatus = _c.networkStatus;
    var refetchList = function () {
        return refetch(__assign({ sorts: sorts }, filter));
    };
    react_1.useEffect(function () {
        refetchList();
    }, [json_stable_stringify_1.default(filter), json_stable_stringify_1.default(sorts)]);
    react_1.useEffect(function () {
        if (location.state && location.state.refetch) {
            refetchList();
        }
    }, [location.state]);
    react_1.useEffect(function () {
        if (refetchTimestamp > 0) {
            refetchList();
        }
    }, [refetchTimestamp]);
    var getListData = function () { return util_1.ObjectUtil.get(data, pathToList); };
    var onSort = function (columnId, direction) {
        setSorts([[columnId, direction]]);
    };
    var isLoading = function () {
        return loading || networkStatus === client_1.NetworkStatus.refetch;
    };
    react_1.useEffect(function () {
        if (onDataChange) {
            var pageData = getListData();
            onDataChange(pageData);
        }
    }, [data]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ac_ui_1.AcDataList, { data: getListData(), functionContext: { filter: filter, listData: getListData(), client: client, refetch: refetch }, loading: loading, columns: columns, grid: grid, onSort: onSort, sorts: sorts, highlight: highlight, totalElements: (_b = (_a = getListData()) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0, onRowClick: onRowClick, whenLoading: whenLoading, whenNoData: whenNoData, hideHeader: hideHeader })));
};
exports.AcListedDataList = AcListedDataList;
exports.AcListedDataList.displayName = 'AcListedDataList';
//# sourceMappingURL=AcListedDataList.js.map